// extracted by mini-css-extract-plugin
module.exports = {"infoBlock":"HistoryAndMessages_infoBlock__33rfn"};